import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import useCardTheme from './themes';

type CardCategoryProps = {
  children: JSX.Element;
  classes?: string;
};

function CardCategory({ children, classes }: CardCategoryProps) {
  const { categoryVariantClasses } = useCardTheme();

  return <span className={twMerge(categoryVariantClasses, classes)}>{children}</span>;
}

export default CardCategory;
